{
  "aNotificationWillBeSendToToAllLinkedPhoneNumbersWhenAnyOfTheseStateChangesOccurs": "Une notification sera envoyée à tous les numéros de téléphone liés lorsque l’un de ces changements d’état se produit...",
  "aboutCustomNotifications": "À propos des notifications personnalisées",
  "addYourPhoneNumber": "Ajoutez votre numéro de téléphone",
  "changesFrom": "changements de:",
  "createNotificationHelpBodyText": "Par défaut, FarmHQ tentera d'avertir tous les membres de votre compte de ferme lorsqu'un événement important se produit.\n\nSi vous souhaitez recevoir des notifications personnalisées pour des appareils spécifiques, vous pouvez définir des règles de notification ici.\n\nFarmHQ peut vous avertir lorsqu'un capteur de votre appareil passe d'un état à un autre. Assurez-vous que les utilisateurs de votre compte de ferme ont vérifié leurs numéros de téléphone dans les paramètres de leur compte.\n\nVous devez avoir l'autorisation de gérer les notifications personnalisées pour créer ou supprimer des règles de notification.",
  "deleteThisRule": "Supprimer cette règle ?",
  "errorMessageAlreadyCreated": "Cette règle existe déjà pour cet appareil.",
  "newNotificationRule": "Nouvelle règle de notification",
  "newRule": "Nouvelle règle",
  "noCustomNotificationRulesHaveBeenCreatedForThisDevice": "Aucune règle de notification personnalisée n'a été créée pour cet appareil.",
  "noVerifiedPhoneNumbersMessage": "Vous n'avez aucun numéro de téléphone vérifié.\nVous pouvez enregistrer et vérifier les numéros de téléphone dans le menu des paramètres de votre compte.",
  "noVerifiedPhoneNumbersTitle": "Aucun numéro de téléphone vérifié",
  "notificationRules": "Règles de notification",
  "notifications": "Notifications",
  "notificationsDisabled": "Notifications désactivées",
  "notificationsEnabled": "Notifications activées",
  "sendANotificationToAllPhoneNumbersWhenThisStateChangeHappens": "Envoyer une notification à tous les numéros de téléphone lorsque ce changement d'état se produit...",
  "sendANotificationWhen": "Envoyer une notification lorsque...",
  "autoMutedExplanation": "Cet appareil a été automatiquement mis en sourdine car il envoyait trop de notifications. Vous pouvez le réactiver pour recommencer à recevoir des notifications.",
  "deviceMuted": "Appareil en sourdine",
  "deviceMutedBanner": "Toutes les notifications de cet appareil sont actuellement en sourdine.",
  "muteDevice": "Mettre en sourdine",
  "unmute": "Réactiver",
  "notificationChannel": "Canal de notification",
  "notificationChannelDescription": "Choisissez comment recevoir les notifications de vos appareils.",
  "channelSms": "SMS uniquement",
  "channelPush": "Push uniquement",
  "channelBoth": "SMS et push",
  "channelNone": "Aucune",
  "channelPreferenceUpdated": "Préférence de canal de notification mise à jour.",
  "notificationMode": "Mode de notification",
  "notificationModeEnabled": "Activé",
  "notificationModeSuppressed": "Supprimé",
  "notificationPreferences": "Notification Preferences",
  "managePhoneNumbers": "Manage Phone Numbers",
  "manageNotificationsByDevice": "Manage Notifications by Device",
  "viewNotificationMap": "View on Map",
  "notificationMapTitle": "Notification Map",
  "legendEnabled": "Actif",
  "legendSuppressed": "En sourdine pour moi",
  "legendMuted": "En sourdine pour tous",
  "noDevicesMessage": "No devices found.",
  "personalPreferencesOnly": "These preferences apply only to your account.",
  "manageDevicesDescription": "These settings only affect your notifications. Other users' preferences are not changed.",
  "affectsOnlyYou": "This setting affects only your notifications.",
  "muteForAllUsers": "Mute for All Users",
  "muteForAllUsersDescription": "When muted, no users will receive notifications from this device.",
  "mutedByUserAt": "Muted by {{email}} on {{date}}.",
  "autoMutedAt": "Automatically muted on {{date}} due to excessive notifications.",
  "notificationSettings": "Notification Settings",
  "muteForMe": "Mute for Me",
  "muteForMeDescription": "Mute notifications from this device for your account only.",
  "mutedForMe": "Muted for you",
  "unmutedForMe": "Unmuted for you",
  "deviceMuteStatus": "Device Mute",
  "stateEnabled": "Active",
  "stateMutedForMe": "En sourdine pour moi",
  "stateMutedForAll": "En sourdine pour tous",
  "disabledByAdmin": "Notifications desactivees par un administrateur.",
  "sendTestNotification": "Envoyer une notification de test",
  "sendTestNotificationQuestion": "Envoyer une notification de test ?",
  "sendTestToMe": "M'envoyer un test",
  "sendTestToFarm": "Envoyer un test a tous",
  "testNotificationDescription": "Envoyez-vous un test pour verifier que les notifications fonctionnent, ou testez tous les utilisateurs de votre ferme.",
  "testNotificationFarmWarning": "Tous les utilisateurs de cette ferme recevront cette notification de test, selon leurs propres parametres de notification.",
  "testNotificationDeviceWarning": "Tous les utilisateurs configures pour recevoir les notifications de cet appareil recevront cette notification de test.",
  "testNotificationSent_one": "Notification de test envoyee a {{count}} destinataire.",
  "testNotificationSent_other": "Notification de test envoyee a {{count}} destinataires.",
  "testNotificationPermissionRequired": "Vous avez besoin de l'autorisation de gerer les notifications des appareils pour tester tous les utilisateurs de votre ferme."
}
